import recordScreen from './RecordScreen.png';
import {MicOutlined} from "@mui/icons-material";
import React from "react";

const RecordScreenIcon = () => {
    return <img src={recordScreen} alt="G icon" width="63px" height="46px" />;
};

export const RecordAudioOnlyIcon = () => {
    return <MicOutlined sx={{color: "#999", width: "60px", height: "42px"}}/>;
}

export default RecordScreenIcon;